/* CamGuard Coming Soon. Native interaction patterns inspired by credited 21st components. */
(() => {
  'use strict';
  if (window.CgComingSoon) { window.CgComingSoon.init(); return; }
  const instances = new Map();
  function initialise(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const listen = (node, type, handler, options = {}) => node?.addEventListener(type, handler, {...options, signal:controller.signal});
    const tabs = [...root.querySelectorAll('.cs-product-tabs [role="tab"]')];
    const panels = [...root.querySelectorAll('.cs-product-panel')];
    const button = root.querySelector('.cs-motion-toggle');
    const stage = root.querySelector('.cs-hero-stage');
    const panelFrame = root.querySelector('.cs-product-panels');
    const shimmer = root.querySelector('.cs-shimmer');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
    let userPaused = false;
    let frame = 0;
    let lastPointer = null;
    let depthVisible = true;
    let ctaVisible = false;
    let entryTimer = 0;
    let arrivalTimer = 0;
    let stageTimer = 0;
    let stagePending = false;
    let energy = null;
    let screen = null;
    let screenTimer = 0;
    let heroTimer = 0;
    try { userPaused = sessionStorage.getItem('cg-coming-motion-paused') === 'true'; } catch (_) { /* storage is optional */ }
    const paused = () => userPaused || reduced.matches || document.hidden;
    // A finite launch reveal. Baseline content stays visible without JavaScript.
    function finishArrival() {
      clearTimeout(arrivalTimer);
      clearTimeout(heroTimer);
      root.classList.remove('cs-entry-playing');
      if (root.dataset.entry === 'playing') root.dataset.entry = 'complete';
    }
    function finishStage() {
      clearTimeout(stageTimer);
      stage.classList.remove('cs-stage-entering');
      energy?.remove(); energy = null;
      if (stage.dataset.entry === 'playing') stage.dataset.entry = 'complete';
    }
    function cancelArrival() {
      stagePending = false;
      finishArrival(); finishStage(); finishScreen();
    }
    function finishScreen() {
      clearTimeout(screenTimer);
      screen?.remove(); screen = null;
    }
    function revealScreen() {
      screen = document.createElement('div');
      screen.id = 'cg-coming-transition';
      screen.setAttribute('aria-hidden', 'true');
      for (const name of ['cg-screen-panel cg-screen-top', 'cg-screen-panel cg-screen-bottom', 'cg-screen-seam', 'cg-screen-orbit cg-screen-orbit-one', 'cg-screen-orbit cg-screen-orbit-two']) {
        const part = document.createElement('span');
        part.className = name; screen.append(part);
      }
      const message = document.createElement('div');
      message.className = 'cg-screen-message';
      const brand = document.createElement('span');
      brand.className = 'cg-screen-brand';
      brand.textContent = 'CamGuard Australia';
      const title = document.createElement('span');
      title.className = 'cg-screen-title';
      title.textContent = 'One step ahead.';
      const note = document.createElement('span');
      note.className = 'cg-screen-note';
      note.textContent = 'Coming soon / Anker eufy';
      message.append(brand, title, note);
      screen.append(message);
      // Attach outside the section so transformed theme ancestors cannot crop it.
      document.body.append(screen);
      screenTimer = window.setTimeout(finishScreen, 2400);
    }
    function revealStage() {
      if (!stagePending || paused()) return;
      stagePending = false;
      energy = document.createElement('span');
      energy.className = 'cs-launch-energy';
      energy.setAttribute('aria-hidden', 'true');
      for (const name of ['cs-energy-orbit', 'cs-energy-orbit cs-energy-echo', 'cs-energy-flare']) {
        const element = document.createElement('span');
        element.className = name; energy.append(element);
      }
      stage.append(energy);
      stage.dataset.entry = 'playing';
      stage.classList.add('cs-stage-entering');
      stageTimer = window.setTimeout(finishStage, 1600);
    }
    function startArrival() {
      // The shared, marked-navigation entrance now owns arrival.
      root.dataset.entry = 'skipped';
    }
    function resetDepth() {
      root.querySelectorAll('.cs-product-panel .cs-panel-visual').forEach(visual => {
        visual.style.removeProperty('--depth-x');
        visual.style.removeProperty('--depth-y');
        visual.style.removeProperty('--depth-shift-x');
        visual.style.removeProperty('--depth-shift-y');
      });
    }
    function prepareFeatureCallouts() {
      for (const panel of panels) {
        const visual = panel.querySelector('.cs-panel-visual');
        const facts = [...panel.querySelectorAll('.cs-specs > div')].slice(0, 3);
        if (!visual || facts.length < 2 || visual.querySelector('.cs-depth-callouts')) continue;
        const group = document.createElement('div');
        group.className = 'cs-depth-callouts';
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', 'Product feature callouts');
        for (const [index, fact] of facts.entries()) {
          const label = fact.querySelector('dt')?.textContent.trim();
          const value = fact.querySelector('dd')?.textContent.trim();
          if (!label || !value) continue;
          const callout = document.createElement('button');
          callout.type = 'button';
          callout.className = 'cs-depth-callout';
          callout.setAttribute('aria-pressed', String(index === 0));
          const calloutLabel = document.createElement('span');
          const calloutValue = document.createElement('strong');
          calloutLabel.textContent = label;
          calloutValue.textContent = value;
          callout.append(calloutLabel, calloutValue);
          listen(callout, 'click', () => {
            group.querySelectorAll('.cs-depth-callout').forEach(item => item.setAttribute('aria-pressed', String(item === callout)));
          });
          group.append(callout);
        }
        if (group.children.length) visual.append(group);
      }
    }
    function syncMotion() {
      root.classList.toggle('cs-is-paused', paused());
      shimmer.style.setProperty('animation-play-state', paused() || !ctaVisible ? 'paused' : 'running');
      shimmer.classList.toggle('cs-shimmer-paused', paused() || !ctaVisible);
      const stopped = userPaused || reduced.matches;
      button.setAttribute('aria-pressed',String(stopped));
      button.setAttribute('aria-label',reduced.matches ? 'Motion is reduced by your device setting' : stopped ? 'Resume page motion' : 'Pause page motion');
      button.querySelector('span').textContent = reduced.matches ? 'Reduced motion' : stopped ? 'Resume motion' : 'Pause motion';
      button.disabled = reduced.matches;
      if (paused()) { cancelArrival();cancelAnimationFrame(frame);frame=0;resetDepth(); }
    }
    function choose(tab, focus = false) {
      if (!tab) return;
      const changed = tab.getAttribute('aria-selected') !== 'true';
      for (const item of tabs) {const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;}
      for (const panel of panels) {panel.hidden=panel.id!==tab.getAttribute('aria-controls');panel.classList.remove('cs-is-entering');}
      const selected = panels.find(panel=>!panel.hidden);
      resetDepth();
      clearTimeout(entryTimer);
      if (changed && selected && !paused()) {
        selected.classList.add('cs-is-entering');
        entryTimer=window.setTimeout(()=>selected.classList.remove('cs-is-entering'),750);
      }
      if (focus) tab.focus({preventScroll:true});
    }
    for (const [index, tab] of tabs.entries()) {
      listen(tab,'click',()=>choose(tab));
      listen(tab,'keydown',event=>{
        let next;
        if (['ArrowRight','ArrowDown'].includes(event.key)) next=(index+1)%tabs.length;
        else if (['ArrowLeft','ArrowUp'].includes(event.key)) next=(index-1+tabs.length)%tabs.length;
        else if (event.key==='Home') next=0;
        else if (event.key==='End') next=tabs.length-1;
        else return;
        event.preventDefault();choose(tabs[next],true);
      });
    }
    root.querySelectorAll('[data-select-product]').forEach(link=>listen(link,'click',()=>choose(tabs.find(tab=>tab.id==='tab-'+link.dataset.selectProduct),true)));
    listen(button,'click',()=>{userPaused=!userPaused;try{sessionStorage.setItem('cg-coming-motion-paused',String(userPaused));}catch(_){}syncMotion();});
    listen(document,'visibilitychange',syncMotion);
    listen(reduced,'change',syncMotion);
    listen(window,'pagehide',cancelArrival);
    listen(document,'pointerdown',event=>{if(screen || event.target.closest('a,button,input,summary'))cancelArrival();},{passive:true});
    listen(window,'wheel',()=>{if(screen)cancelArrival();},{passive:true});
    listen(document,'keydown',cancelArrival);
    listen(window,'hashchange',cancelArrival);
    function paintPointer() {
      frame=0;
      if (!lastPointer || paused() || !finePointer.matches) return;
      const {x,y,target}=lastPointer;
      const visual = root.querySelector('.cs-product-panel:not([hidden]) .cs-panel-visual');
      if (depthVisible && visual?.contains(target) && innerWidth>620) {
        const rect=visual.getBoundingClientRect();const px=(x-rect.left)/rect.width-.5;const py=(y-rect.top)/rect.height-.5;
        visual.style.setProperty('--depth-x',(px*2.5).toFixed(2)+'deg');visual.style.setProperty('--depth-y',(-py*2.5).toFixed(2)+'deg');
        visual.style.setProperty('--depth-shift-x',(px*5).toFixed(1)+'px');visual.style.setProperty('--depth-shift-y',(py*5).toFixed(1)+'px');
      } else resetDepth();
      if (panelFrame.contains(target)) {const rect=panelFrame.getBoundingClientRect();const angle=Math.atan2(y-rect.top-rect.height/2,x-rect.left-rect.width/2)*180/Math.PI+90;panelFrame.style.setProperty('--glow-angle',angle+'deg');}
    }
    listen(root,'pointermove',event=>{
      if (event.pointerType==='touch' || paused() || !finePointer.matches) return;
      lastPointer={x:event.clientX,y:event.clientY,target:event.target};
      if (!frame) frame=requestAnimationFrame(paintPointer);
    },{passive:true});
    listen(panelFrame,'pointerleave',resetDepth);
    let observer;
    if ('IntersectionObserver' in window) {
      observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.target===stage&&entry.intersectionRatio>=.08)revealStage();if(entry.target===panelFrame){depthVisible=entry.isIntersecting;if(!depthVisible)resetDepth();}if(entry.target===shimmer)ctaVisible=entry.isIntersecting;}syncMotion();},{threshold:[0,.08]});
      observer.observe(stage);observer.observe(panelFrame);observer.observe(shimmer);
    } else ctaVisible=true;
    prepareFeatureCallouts();
    syncMotion();
    root.classList.add('cs-motion-ready');
    startArrival();
    instances.set(root,()=>{cancelArrival();controller.abort();observer?.disconnect();cancelAnimationFrame(frame);clearTimeout(entryTimer);instances.delete(root);});
  }
  const init=()=>document.querySelectorAll('[data-cg-coming]').forEach(initialise);
  window.CgComingSoon={init};
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>{for(const [root,destroy] of instances){if(event.target.contains(root))destroy();}});
  init();
})();
